import { Box, Typography } from "@mui/material";
import GradientIcon from "../../components/GradientIcon";

export default function BenefitItem({ icon, title, desc }) {
  return (
    <Box
      sx={{
        display: "flex",
        // alignItems: "center",
        // alignItems: "flex-start",
        gap: "16px",
        // pb: "16px",
        // pt: "8px",
        // borderRadius: "16px",
        mb: "32px",
        transition: "all 0.3s ease",
        cursor: "pointer",
        "&:hover": {
          background:
            "linear-gradient(107.5deg, rgba(114, 79, 211, 0), rgba(252, 134, 175, 0.1))",
        },
      }}
    >
      {/* Icon */}
      <GradientIcon
        icon={icon}
        size={24}
        bordered
        boxSize={48}
        borderRadius={8}
        borderWidth={2}
        // angle="90"
        // sx={{ margin: "0 auto 16px" }}
      />

      {/* <Box
        sx={{
          width: 48,
          height: 48,
          borderRadius: "8px",
          border: "2px solid transparent",
          background:
            "linear-gradient(#fff,#fff) padding-box, linear-gradient(141.98deg,#FF7FAC,#5834BA) border-box",
          // display: "flex",
          // alignItems: "center",
          // justifyContent: "center",
          // flexShrink: 0,
        }}
      >
        {icon}
      </Box> */}

      {/* Title & Description */}
      <Box>
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: 500,
            lineHeight: "175%",
            letterSpacing: "0.15px",
          }}
        >
          {title}
        </Typography>

        <Typography variant="body2" sx={{ color: "#666666" }}>
          {desc}
        </Typography>
      </Box>
    </Box>
  );
}
